module.exports = __webpack_public_path__ + "static/media/icons.3a891e45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons.svg
// module id = 255
// module chunks = 0